import React, { useState, useEffect } from "react";
import OTPInput, { ResendOTP } from "otp-input-react";
import OtpInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";
import { getOtp, resendOtp, verifyOtp } from "../../redux/actionCreator";
import { toast } from "react-toastify";
import {
  hide_send_otp,
  otp_id,
  otp_loader,
  profile_validated,
  showOtpSection,
  showTimer,
  updateRedux,
  verify_status,
} from "../../redux/commonReducer";
import { onOTPrequestValidation } from "../../utils/validation";
import Timer from "./timer";
import { useTranslation } from "react-i18next";
import { isNumericLiteral } from "@babel/types";
import { useLocation, useNavigate } from "react-router-dom";

export default function Page2({
  setStage,
  setInputs,
  inputs,
  setInputErrors,
  inputErrors,
  timer,
  setTimer,
  intervalId,
  setIntervalId,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const location = useLocation();
  const lang = localStorage.getItem("lang");
  const navigate = useNavigate();

  const [OTP, setOTP] = useState("");
  const [captchaValue, setCaptchaValue] = useState("");
  const [value, setValue] = useState("");
  const [captchaErr, setCaptchaErr] = useState("");
  const [isDisabledSendOtp, setIsdisabledSendOtp] = useState(false)
  const [isDisabledResend, setIsdisabledResend] = useState(false)

  // const [profileValidated, setProfileValidated] = useState(null);

  const otpId = useSelector(otp_id);
  const verifyStatus = useSelector(verify_status);
  const showOtp = useSelector(showOtpSection);
  const time = useSelector(showTimer);
  const loader = useSelector(otp_loader);
  const hide_send_btn = useSelector(hide_send_otp);
  const profileValidated = useSelector(profile_validated);

  useEffect(() => {
    setInputErrors({});
    // location.pathname = location.pathname + '/personal_information'
    // window.location.pathname += '/personal_information'
  }, []);

  useEffect(() => {
    let otpInput = document.querySelector(".otp-input");
    let inputs = otpInput?.querySelectorAll("input");
    inputs?.forEach((i) => {
      i.setAttribute("type", "number");
    });
  }, [showOtp]);

  useEffect(() => {
    if (!hide_send_btn) {
      createCaptcha();
    }
  }, [hide_send_btn]);

  async function onOTPrequestHandle() {
    const isValidated = await onOTPrequestValidation(
      {
        first_name: inputs.first_name,
        last_name: inputs.last_name,
        email: inputs.email,
        phone_number: inputs.phone_number,
        emirates_id: inputs.emirates_id,
        // emirates_id_proof: inputs.emirates_id_proof
      },
      setInputErrors
    );
    // setProfileValidated(isValidated);
    dispatch(updateRedux({ key: "profile_validated", value: isValidated }));
    let validCaptcha;
    if (validateCaptcha()) {
      validCaptcha = true;
    } else {
      validCaptcha = false;
      setCaptchaErr("Invalid Captcha");
    }
    if (isValidated && validCaptcha) {
      dispatch(updateRedux({ key: "otp_loader", value: true }));
      let data = {
        email: inputs.email,
        phone: inputs.phone_number,
        first_name: inputs.first_name,
        last_name: inputs.last_name,
        emirates_id: inputs.emirates_id,
        // emirates_id_proof: inputs.emirates_id_proof[0],
        language: localStorage.getItem("lang"),
      };
      setIsdisabledSendOtp(true)
      dispatch(
        getOtp(data, (res) => {
          setTimer("00:03:00");
          setIsdisabledSendOtp(false)

        })
      );
    }
  }

  const onNextHandler = async () => {
    const isValidated = await onOTPrequestValidation(
      {
        first_name: inputs.first_name,
        last_name: inputs.last_name,
        email: inputs.email,
        phone_number: inputs.phone_number,
        emirates_id: inputs.emirates_id,
        // emirates_id_proof: inputs.emirates_id_proof
      },
      setInputErrors
    );
    // setProfileValidated(isValidated);
    dispatch(updateRedux({ key: "profile_validated", value: isValidated }));
    if (isValidated === true && inputs.otp?.length == 4) {
      setInputErrors({});
      // navigate(-1)
      navigate(`/${lang}/report_incident/incident_report`);
    }
  };

  const onResendHandler = () => {
    setInputs((s) => ({ ...s, otp: "" }));
    if (otpId?.length) {
      let data = {
        otp_id: otpId,
        language: localStorage.getItem("lang"),
      };
      setIsdisabledResend(true)
      dispatch(
        resendOtp(data, (res) => {
          setTimer("00:03:00");
          setIsdisabledResend(false)
        })
      );
    }
  };

  // useEffect(() => {
  //   if (inputs.otp?.length === 4) {
  //     let data = {
  //       otp: inputs.otp,
  //       otp_id: otpId,
  //     };
  //     dispatch(verifyOtp(data));
  //   }
  // }, [inputs.otp]);

  const otpChangeHandler = (e) => {
    setInputs((s) => ({ ...s, otp: e }));
    if (e.length == 4) {
      let data = {
        otp: e,
        otp_id: otpId,
        language: localStorage.getItem("lang"),
        phone: '971' + inputs?.phone_number || ''
      };
      dispatch(
        verifyOtp(data, () => {
          if (intervalId) {
            clearInterval(intervalId);
          }
          toast.success(t("OTP verified successfully"), {
            position: "bottom-center",
            autoClose: 3000,
          });
        })
      );
    }
  };

  function createCaptcha() {
    //clear the contents of captcha div first
    let code;
    document.getElementById("captcha").innerHTML = "";
    let charsArray =
      "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ@!#$%^&*";
    let lengthOtp = 6;
    let captcha = [];
    for (let i = 0; i < lengthOtp; i++) {
      //below code will not allow Repetition of Characters
      var index = Math.floor(Math.random() * charsArray.length + 1); //get the next character from the array
      if (captcha.indexOf(charsArray[index]) == -1)
        captcha.push(charsArray[index]);
      else i--;
    }
    let canv = document.createElement("canvas");
    canv.id = "captcha";
    canv.width = 150;
    canv.height = 50;
    let ctx = canv.getContext("2d");
    ctx.font = "25px Georgia";
    ctx.strokeText(captcha.join(""), 0, 30);
    //storing captcha so that can validate you can save it somewhere else according to your specific requirements
    code = captcha.join("");
    document.getElementById("captcha").appendChild(canv); // adds the canvas to the body element
    setCaptchaValue(code);
    // console.log(code);
  }

  const validateCaptcha = () => {
    return captchaValue == value;
  };

  return (
    // console.log(inputs),
    <div className="Page2 container">
      <section>
        <h2>{t("please_fill_in_your_personal_information")}</h2>
        {/* <p>Fill the mandatory fields</p> */}
        <div className="personal-info-form container">
          <div className="input-group">
            <input
              type="text"
              placeholder={`${t("first_name")}*`}
              value={inputs.first_name}
              className={inputErrors.first_name ? "error" : ""}
              onChange={(e) => (
                setInputs((s) => ({ ...s, first_name: e.target.value })),
                setInputErrors({ ...inputErrors, first_name: "" })
              )}
              disabled={loader ? true : hide_send_btn ? true : false}
            />
            <div className="text-danger">
              <small>{t(inputErrors.first_name)}</small>
            </div>
          </div>
          <div className="input-group">
            <input
              type="text"
              placeholder={`${t("last_name")}*`}
              value={inputs.last_name}
              className={`${inputErrors.last_name ? "error" : ""}`}
              onChange={(e) => (
                setInputs((s) => ({ ...s, last_name: e.target.value })),
                setInputErrors({ ...inputErrors, last_name: "" })
              )}
              disabled={loader ? true : hide_send_btn ? true : false}
            />
            <div className="text-danger">
              <small>{t(inputErrors.last_name)}</small>
            </div>
          </div>
          <div className="input-group">
            <input
              type="text"
              placeholder={`${t("email")}*`}
              value={inputs.email}
              className={`${inputErrors.email ? "error" : ""}`}
              onChange={(e) => (
                setInputs((s) => ({ ...s, email: e.target.value })),
                setInputErrors({ ...inputErrors, email: "" })
              )}
              disabled={loader ? true : hide_send_btn ? true : false}
            />
            <div className="text-danger">
              <small>{t(inputErrors.email)}</small>
            </div>
          </div>
          <div className="input-group">
            <div className="phone" dir="rtl">
              <input
                type="number"
                dir={lang == "en" ? "ltr" : "rtl"}
                placeholder={`${t("phone_no")}*`}
                value={inputs.phone_number}
                className={`phone_number ${inputErrors.phone_number ? "error" : ""}`}
                maxLength={9}
                onChange={(e) => {
                  setValue("");
                  setInputs((s) => ({
                    ...s,
                    phone_number: e.target.value.length > 9 ? s.phone_number : e.target.value,
                    otp: "",
                  }));
                  setInputErrors({ ...inputErrors, phone_number: "" });
                  setCaptchaErr("");
                  dispatch(
                    updateRedux({ key: "showOtpSection", value: false })
                  );
                  dispatch(updateRedux({ key: "verify_status", value: false }));
                  dispatch(updateRedux({ key: "hide_send_otp", value: false }));
                  dispatch(updateRedux({ key: "otp_loader", value: false }));
                  if (intervalId) {
                    clearInterval(intervalId);
                  }
                }}
              />
              <input
                type="text"
                dir="ltr"
                className="country-code"
                placeholder="+971"
                value={inputs.country_code}
                disabled
                onChange={(e) => (
                  setInputs((s) => ({ ...s, country_code: e.target.value })),
                  setInputErrors({})
                )}
              />
            </div>
            <div className="text-danger">
              <small>{t(inputErrors.phone_number)}</small>
            </div>
          </div>
          <div className="input-group">
            <input
              type="text"
              placeholder={`${t("emirates_id")}`}
              value={inputs.emirates_id}
              className={`${inputErrors.emirates_id ? "error" : ""}`}
              onChange={(e) => (
                setInputs((s) => ({ ...s, emirates_id: e.target.value.length > 15 ? s.emirates_id : e.target.value })),
                setInputErrors({ ...inputErrors, emirates_id: "" })
              )}
              disabled={loader ? true : hide_send_btn ? true : false}
            />
            <div className="text-danger">
              <small>{t(inputErrors.emirates_id)}</small>
            </div>
          </div> 
          {/*  
          <div className="input-group">
            <label htmlFor="emirates_id_proof" className={"emirates_id_proof " + (inputs.emirates_id_proof?.[0]?.name ? 'file' : '')}>
              {inputs.emirates_id_proof?.[0]?.name || `${t("Upload Emirates ID proof")}*`}
              <img src="./assets/img/icons/file-upload-alt-svgrepo-com.svg" alt="" />
            </label>
            <input
              type="file"
              id="emirates_id_proof"
              hidden
              className={`${inputErrors.emirates_id_proof ? "error" : ""}`}
              onChange={(e) => (
                setInputs((s) => ({ ...s, emirates_id_proof: e.target.files })),
                setInputErrors({ ...inputErrors, emirates_id_proof: "" })
              )}
              disabled={loader ? true : hide_send_btn ? true : false}
            />
            <div className="text-danger">
              <small>{t(inputErrors.emirates_id_proof)}</small>
            </div>
          </div>
          */}
        </div>

        {!hide_send_btn ? (
          <div className="d-flex-personal-section">
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div
                className="input-group"
                style={{
                  width: "100%",
                  paddingTop: 15,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  textAlign: "center",
                }}
              >
                <div
                  id="captcha"
                  style={{
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                ></div>
                <input
                  type="text"
                  placeholder={t("enter_captcha")}
                  id="cpatchaTextBox"
                  // className="form-control"
                  style={{ minWidth: 100, textAlign: lang === 'ar' ? 'right' : 'left', direction: 'ltr' }}
                  value={value}
                  onChange={(e) => {
                    setValue(e.target.value);
                    setCaptchaErr("");
                  }}
                />
                {/* <button type = "button" onClick={()=>createCaptcha()}>resend</button> */}
                <i
                  className="bi bi-arrow-repeat"
                  style={{ margin: "0 10px" }}
                  onClick={() => (
                    createCaptcha(), setValue(""), setCaptchaErr("")
                  )}
                ></i>
              </div>
              <div className="text-danger">
                <small>{t(captchaErr)}</small>
              </div>
            </div>
            <div className="send-otp container">
              <button
                onClick={() => onOTPrequestHandle()}
                className={
                  inputs.first_name?.trim() == "" ||
                    inputs.last_name?.trim() == "" ||
                    inputs.email?.trim() == "" ||
                    inputs.phone_number?.trim() == "" ||
                    value?.trim() == ""
                    ? "disabled"
                    : ""
                }
                disabled={
                  inputs.first_name?.trim() == "" ||
                  inputs.last_name?.trim() == "" ||
                  inputs.email?.trim() == "" ||
                  inputs.phone_number?.trim() == "" ||
                  value?.trim() == "" ||
                  isDisabledSendOtp
                }
              >
                {t("send_otp")}
              </button>
            </div>
          </div>
        ) : (
          <div className="send-otp container"></div>
        )}
      </section>
      {loader ? (
        <section style={{ height: "100px" }}>
          <div className="d-flex justify-content-center">
            <div className="spinner-border text-success" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </section>
      ) : (
        <>
          {showOtp ? (
            <section className="enter-otp" style={{ marginTop: '100px' }}>
              <p>
                {t("we_have_sent_you_a_one_time_password_on_your_phone_number")}
              </p>
              <p className="label">{t("enter_the_otp")}</p>
              <div className="otp-input">
                <div className="input-boxes">
                  <OtpInput
                    value={inputs.otp}
                    onChange={(e) => {
                      otpChangeHandler(e);
                    }}
                    numInputs={4}
                    separator={<span> - </span>}
                  />
                </div>
                <div className="timer-button">
                  <Timer
                    disabled={false}
                    timer={timer}
                    setTimer={setTimer}
                    setIntervalId={setIntervalId}
                    intervalId={intervalId}
                  />
                  {!time ? (
                    <button
                      className="btn btn-secondary mb-5"
                      disabled={isDisabledResend}
                      onClick={() => onResendHandler()}
                    >
                      {t("resend")}
                    </button>
                  ) : null}
                </div>
              </div>
            </section>
          ) : (
            <section style={{ height: "100px" }}></section>
          )}
        </>
      )}
      <div className="buttons">
        <button
          className={"next-button back"}
          onClick={() => {
            // setStage(1);
            navigate(`/${lang}/report_incident`);
            dispatch(updateRedux({ key: "continue_timer", value: true }));
          }}
        >
          <img
            className="left arrow"
            src="./assets/img/icons/Icon awesome-arrow-right.svg"
            alt=""
          />
          {t("back")}
        </button>
        <button
          className={"next-button next" + (verifyStatus ? "" : " disabled")}
          onClick={() => onNextHandler()}
          disabled={verifyStatus === true ? false : true}
        >
          {t("next")}
          <img
            className="right"
            src="./assets/img/icons/Icon awesome-arrow-right.svg"
            alt=""
          />
        </button>
      </div>
    </div>
  );
}
